export const clearSearchParameters = () => {
  // clear search path without affecting browser history
  window.history.replaceState({}, document.title, location.hash.split("?")[0]);
};
